/**
 * Act-as token storage. Used by global.ts getAuthHeaders so it can read the token
 * without React context. ActAsContext sets the getter on mount.
 */
const ACT_AS_STORAGE_KEY_TOKEN = "act-as-token";

let storedTokenGetter: () => string | null = () => sessionStorage.getItem(ACT_AS_STORAGE_KEY_TOKEN);

export const getStoredActAsToken = (): string | null => storedTokenGetter();

export const setActAsTokenGetter = (getter: () => string | null) => {
  storedTokenGetter = getter;
};

export const clearActAsTokenGetter = () => {
  storedTokenGetter = () => null;
};
